import React from 'react';
import { NavLink } from 'react-router-dom';
import './AuthScreens.css';
import LoginForm from '../LoginForm/LoginForm';
import SignupForm from '../SignupForm/SignupForm';
import { AUTH_ROUTES } from '../../routes/routingContract';

function AuthBrandLogo({ className = '' }) {
  return (
    <div className={`auth-logo-row ${className}`}>
      <div className="auth-logo-mark" aria-hidden="true">
        <img src={`${process.env.PUBLIC_URL}/wealth-y_logo.png`} alt="" />
      </div>
      <span className="auth-wordmark">Wealth-Y</span>
    </div>
  );
}

export default function AuthScreens({ mode = 'login' }) {
  return (
    <div className="authscreens">
      {/* Left branding panel */}
      <div className="auth-brand-panel" aria-hidden="true">
        <div className="auth-glow auth-glow-tl"></div>
        <div className="auth-glow auth-glow-br"></div>
        <div className="auth-brand-content">
          <AuthBrandLogo />
          <h1 className="auth-headline">
            {mode === 'login' ? (
              <>Clarity on<br /><span className="auth-headline-accent">your money.</span></>
            ) : (
              <>Get clarity<br /><span className="auth-headline-accent">on your money.</span></>
            )}
          </h1>
          <p className="auth-brand-sub">
            {mode === 'signup'
              ? 'Choose a plan and start getting personalized money guidance.'
              : 'Your connected accounts. Real answers. No guesswork.'}
          </p>
          <ul className="auth-trust-list" aria-label="Trust signals">
            <li><span className="auth-trust-dot" aria-hidden="true"></span>Securely connect accounts through Plaid</li>
            <li><span className="auth-trust-dot" aria-hidden="true"></span>Get answers based on your real finances</li>
            <li><span className="auth-trust-dot" aria-hidden="true"></span>We do not sell your personal financial data</li>
          </ul>
        </div>
      </div>

      {/* Right form panel */}
      <div className="auth-form-panel">
        <AuthBrandLogo className="auth-mobile-brand" />

        {/* Sign in / Create account toggle */}
        <div className="auth-mode-toggle" role="tablist">
          <NavLink
            to={AUTH_ROUTES.signIn}
            role="tab"
            aria-selected={mode === 'login'}
            className={({ isActive }) => `auth-mode-btn${isActive ? ' active' : ''}`}
          >
            Sign in
          </NavLink>
          <NavLink
            to={AUTH_ROUTES.createAccount}
            role="tab"
            aria-selected={mode === 'signup'}
            className={({ isActive }) => `auth-mode-btn${isActive ? ' active' : ''}`}
          >
            Create account
          </NavLink>
        </div>

        {mode === 'login' ? (
          <LoginForm />
        ) : (
          <SignupForm />
        )}
      </div>
    </div>
  );
}
